import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

import { TypeBlock, TypeSchool } from '../../../../types';

interface IProps {
    selectedBlock: TypeBlock;
    setSchool: ([]) => void;
    setSelectedSchool: (e: null | TypeSchool) => void;
    changeSchoolFilters: (e: TypeSchool) => void;
    fetchSchools: () => void;
    selectedSchool: TypeSchool;
    school: TypeSchool[];
    schoolFilter: boolean;
};

function SchoolFilter({
    selectedBlock,
    setSchool,
    setSelectedSchool,
    changeSchoolFilters,
    fetchSchools,
    selectedSchool,
    school,
    schoolFilter
}: IProps) {

    // --- DROPDOWN SCHOOL TYPE ---
    const [schoolDropdownOpen, setSchoolDropdownOpen] = useState(false);
    const schoolTypeToggle = () => setSchoolDropdownOpen(prevState => !prevState);

    useEffect(() => {
        if (selectedBlock?.id) {
            setSchool([]);
            setSelectedSchool(null);
            changeSchoolFilters({
                block: 0,
                board: 0,
                city: "",
                created_on: "",
                id: 0,
                medium: 0,
                name: "",
                owner: 0,
                school_code: ""
            });
            fetchSchools();
        }
        console.log("------ School component ------");
    }, [selectedBlock]);

    return (
        <React.Fragment>
            {schoolFilter ? <Dropdown size="sm" isOpen={schoolDropdownOpen} direction="down" toggle={schoolTypeToggle}>
                <DropdownToggle caret>
                    {selectedSchool
                    ? 
                    <span>School: <span className="text-primary text-capitalize">{selectedSchool?.name?.slice(0, 20)}</span></span> 
                    : 
                    'School: All'}
                </DropdownToggle>
                <DropdownMenu>
                    {
                        school?.length !== 0 ? school?.map((each, index) => (
                            <DropdownItem key={index} onClick={() => changeSchoolFilters(each)}>
                                <div className="d-flex justify-content-between align-items-center">
                                    {each?.name}
                                    {selectedSchool?.id === each?.id && <i className="fas fa-check-circle text-primary"></i>}
                                </div>
                            </DropdownItem>
                        )) : <span className="small text-muted text-center">Select District and  Block First</span>
                    }
                </DropdownMenu>
            </Dropdown> : <></>}
        </React.Fragment>
    )
}

export default React.memo(SchoolFilter);